var WDN = WDN || {};

if (typeof WDN.Queue === "undefined") {
	WDN.Queue = (function () {
		var queue, isRunning, start, timer;

		var config = {
			waitTime: 350, // ms
		};

		queue = function (callback) {
			if (!isRunning) {
				start(callback);
			} else {
				clearTimeout(timer);
				start(callback);
			}
		};

		start = function (callback) {
			isRunning = true;
			timer = setTimeout(function () {
				typeof callback === "function" ? callback() : "";
				isRunning = false;
			}, config.waitTime);
		};

		return queue;
	})();
}

class WDNElement extends HTMLElement {
	constructor() {
		super();

		// shared states between components
		this.setupStates = function () {
			// will create attribute as "data-[array key]""
			var statesToHandle = ["loading", "disabled", "active", "hide"];

			statesToHandle.forEach(function (label) {
				// functions to update state, called like => this.loading(); this.loading(false);
				this[label] = this.updateAttribute(label);
			}, this);
		};

		this.init = function () {
			this.setupStates();
		};

		this.init();
	}

	/* ADDING EVENT LISTENERS FOR LIST OF ITEMS */
	on(event, selector, toDo) {
		/*
						param @event *string
						- name of event you want to listen for,
						e.g.: click, mouseover, etc.

						param @selector *string
						- HTML selector to use, can be class, data-attribute etc.

						param @toDo *function
						- your function
						*/

		var list = this.querySelectorAll(selector);

		list.forEach(function (item) {
			item.addEventListener(event, toDo);
		});
	}

	updateAttribute(name) {
		return function (value) {
			var attrName = "data-" + name;
			// eg. this.loading(); this.loading(true)
			if (typeof value === "undefined" || value) {
				this.setAttribute(attrName, "");
			} else {
				this.removeAttribute(attrName);
			}
		}.bind(this);
	}

	// helper function for having a custom events
	customEvent(data) {
		var newEvent = new CustomEvent(data.name, {
			detail: data.detail,
		});
		if (data.selector) {
			var target = document.querySelector(data.selector);
		}

		if (!target) {
			var target = data.target || document.body;
		}
		target.dispatchEvent(newEvent);
	}

	// adds event to window
	addEvent(event, func) {
		return window.addEventListener(event, func);
	}
	// removes event from window
	removeEvent(event, func) {
		return window.removeEventListener(event, func);
	}
}

class WDNFilterGroup extends WDNElement {
	constructor() {
		super();
		this.id = this.getAttribute("data-id");
		this.filters = this.querySelectorAll("wdn-filter");
		this.reset = this.querySelector("[data-reset]");
		this.isHidden = this.getAttribute("data-hide") === "";
		this.groupParam = this.getAttribute("data-group-param");
		this.activeFilter_labels = this.querySelectorAll("[data-active-filters]");
		document.body.addEventListener(
			"filtergroup:update",
			this.onFilterGroupUpdate.bind(this)
		);
	}

	onFilterGroupUpdate(e) {
		if (this.id !== e.detail) return;
		this.outputActiveFilters();
	}
	hide() {
		this.isHidden = true;
		this.setAttribute("data-hide", "");
	}

	clearSelections() {
		this.filters.forEach(function (filter) {
			if (filter.isActive) {
				filter.setInactive();
			}
		});
	}

	show() {
		this.isHidden = false;
		this.removeAttribute("data-hide");
	}

	validateDisabledFilters() {
		// comparing disabled count to filters length, then showing/hiding the whole group
		this.disabledFilterCount >= this.filters.length ? this.hide() : this.show();
	}

	countDisabledFilters() {
		this.disabledFilterCount = 0;
		this.filters.forEach(function (filter) {
			if (filter.isDisabled) {
				this.disabledFilterCount++; // counting the number of disabled filters
			}
		}, this);
	}

	getActiveFilterList() {
		var data = [];

		this.filters.forEach(function (filter) {
			var filterValue = filter.dataset.formattedFilterLabel || filter.value;
			if (
				filter.isActive ||
				filter.type == "sort_by" ||
				filter.type == "price_range"
			) {
				switch (filter.type) {
					case "price_range":
						filterValue = WDN.Money.Format(filter.item.value * 100);
						break;
					case "sort_by":
						filterValue = filter.item.placeholder_value;
						break;
					case "list":
						if (filter.param == "filter.v.availability") {
							filterValue = filter.label;
						}
						if (filter.param.indexOf("colour_every") > -1) {
							filterValue = filter.label;
						}
						break;
				}

				data.push(filterValue);
			}
		});
		return data;
	}

	outputActiveFilters() {
		var list = this.getActiveFilterList();
		var content = "";
		if (list.length > 0) {
			content =
				this.groupParam == "filter.v.price"
					? list.join(" - ")
					: list.join(", ");
		}

		this.activeFilter_labels.forEach(function (label) {
			label.innerHTML = content;
		});
	}

	showReset() {
		if (this.reset) {
			this.reset.removeAttribute("data-ghost");
		}
	}

	hideReset() {
		if (this.reset) {
			this.reset.setAttribute("data-ghost", "");
		}
	}

	validateActiveFilters() {
		this.hideReset(); // hides reset initially
		this.filters.forEach(function (filter) {
			if (filter.isActive) {
				this.showReset(); // shows reset button
				return; // breaking the loop, it is enough to determine if one of the filters is active
			}
		}, this);
	}

	validateFilters() {
		this.countDisabledFilters();
		this.validateActiveFilters();
		this.validateDisabledFilters();
	}
}

class WDNFilter extends WDNElement {
	constructor() {
		super();
		// config
		this.config = {
			output_attribute: "data-filter-output", // output attribute
			template: WDN.FilterConfig.template,
			price_range_attribute: "data-filter-price", // output attribute for price range eg. data-filter-price="max"
		};
		this.parent = this.parentNode;
		this.id = this.getAttribute("data-id");
		this.groupId = this.getAttribute("data-group");
		this.group = this.closest("wdn-filter-group");
		this.item =
			this.querySelector("input") ||
			this.querySelector("select") ||
			this.querySelector("wdn-select"); // item can be either input or select
		this.type = this.item.getAttribute("data-filter-type"); // can be "list" or "price_range", check {{ filter }} object
		this.base_url = WDN.FilterConfig.current_url; // /collection/[handle] or /search
		this.param = this.item.getAttribute("data-filter-param"); // param name
		this.value = this.item.getAttribute("value"); // param value
		this.isActive = this.getAttribute("data-filter-active") === "true"; // initial state
		this.isDisabled = this.parent.getAttribute("data-disabled") === "";
		this.label = this.getAttribute("data-filter-label");
		this.count = this.querySelector("[data-filter-count]");
		this.start(); // init
	}

	setHistoryState(data) {
		history.pushState({}, "", data);
	}

	// template fetch success
	onFetchSuccess(res) {
		document.dispatchEvent(
			new CustomEvent("filters:fetch:success", {
				detail: { res: res, settings: false },
			})
		);
	}

	getRequestUrl() {
		var searchInCollection = document.querySelector("search-in-collection");

		if (searchInCollection) {
			if (searchInCollection.querySelector('input[name="q"]')) {
				var searchInCollectionQuery =
					searchInCollection.querySelector('input[name="q"]');
				var searchInCollectionID = searchInCollection.querySelector(
					'input[name="filter.p.m.product.collection_ids"]'
				);

				if (searchInCollectionQuery.value.length > 0) {
					var viewPrefix = window.location.search === "" ? "?" : "&";

					return (
						"/search" +
						window.location.search +
						viewPrefix +
						"view=" +
						this.config.template +
						"&q=" +
						searchInCollectionQuery.value +
						"&filter.p.m.product.collection_ids=" +
						searchInCollectionID.value
					);
				}
			}
		}

		// normal collection filter
		// check if any params exists, so we know how to append param: ?param="" or &param=""
		var viewPrefix = window.location.search === "" ? "?" : "&";
		return (
			this.base_url +
			window.location.search +
			viewPrefix +
			"view=" +
			this.config.template
		);
	}

	updateLayout() {
		this.setLoading();

		WDN.Request.Get({
			url: this.getRequestUrl(),
			onSuccess: this.onFetchSuccess.bind(this),
			onError: this.onFetchError.bind(this),
		});
	}

	set_count(value) {
		if (!this.count) return;
		this.count.innerHTML = value;
	}

	onFetchError() {
		this.clearLoading();
	}

	addParamToUrl(customValue) {
		var value = customValue || this.item.value || this.value; // custom value / input value / option value
		var urlParams = new URLSearchParams(location.search);
		// checking if current param exists (eg. availability can appear twice in URL with different values)
		if (urlParams.has(this.param) && this.type === "list") {
			urlParams.append(this.param, value); // append it so it doesnt affect the other param
		} else {
			urlParams.set(this.param, value); // set a new param value
		}
		this.setHistoryState(location.pathname + "?" + urlParams); // updating URL
	}

	deleteThisParams() {
		var urlParams = new URLSearchParams(location.search);
		var allParams = Array.from(urlParams);
		urlParams.delete(this.param);
		var updatedParams = location.pathname + "?" + urlParams;
		// if that was last param, set window history state as location.pathname
		if (allParams.length < 1) {
			updatedParams = location.pathname;
		}
		this.setHistoryState(updatedParams);
	}

	migrateParams(currentParams) {
		this.deleteThisParams(); // deleting all URL params that matches this.param
		// since there can be multiple this.params in URL with different values,
		// currentParams holds values of all this.params that were in URL before deleting them
		currentParams.forEach(function (paramValue) {
			// looping through them and putting them back to URL as long as they dont match this.value
			if (paramValue !== this.value) {
				this.addParamToUrl(paramValue); // adds param to url as - this.param = paramValue
			}
		}, this);
	}

	clearCurrentParamValue() {
		var urlParams = new URLSearchParams(location.search);
		// getting all this.param in url
		var currentParams = urlParams.getAll(this.param);
		// eg. filter.v.availability param can appear twice in URL, with values 0 and 1
		if (currentParams.length > 1) {
			// deleting param that matches this.value, and moving the rest back to URL
			this.migrateParams(currentParams);
		} else {
			// deleting all params that match this.param & this.value
			this.deleteThisParams();
		}
	}

	setLoading() {
		document.dispatchEvent(
			new CustomEvent("filters:loading:set", { detail: {} })
		);
	}

	clearLoading() {
		document.dispatchEvent(
			new CustomEvent("filters:loading:clear", { detail: {} })
		);
	}

	debounceLayoutUpdate() {
		var callback = this.updateLayout.bind(this); // actual updatelayout function
		WDN.Queue(callback);
	}

	setState(newState) {
		this.isActive = newState;
		if (newState) {
			this.setAttribute("data-filter-active", "true");
		} else {
			this.removeAttribute("data-filter-active");
		}
	}

	setInactive() {
		this.setState(false);
		this.clearCurrentInput();
		this.deactivateSameFilters(); // loops and deactivates filters with the same this.id
		this.clearCurrentParamValue(); // removes this.param from URL
		this.debounceLayoutUpdate(); // debouncing layout update for better UX
	}

	setActive() {
		this.setState(true);
		this.activateSameFilters(); // loops and activates filters with the same this.id
		this.addParamToUrl(); // sets this.param = this.value in URL
		this.debounceLayoutUpdate(); // debouncing layout update for better UX
	}

	outputActiveFilters() {
		if (!this.group) return;
		this.customEvent({ name: "filtergroup:update", detail: this.groupId });
	}

	clearCurrentInput() {
		if (this.type === "list") {
			this.item.checked = false;
		}
		if (this.type === "price_range") {
			if (this.item.tagName === "INPUT") {
				this.item.value =
					this.param == "filter.v.price.gte" ? 0 : this.item.max / 100;
				this.updateRangeSliders();
			}
		}
	}

	updateRangeSliders() {
		if (this.type !== "price_range") return;
		this.customEvent({
			name: "range_slider:set",
			detail: {
				param: this.param == "filter.v.price.gte" ? "min_price" : "max_price",
				value: this.item.value,
			},
		});
	}

	disable() {
		this.isDisabled = true;
		this.parent.setAttribute("data-disabled", "");
		this.clearCurrentInput();
	}

	enable() {
		this.isDisabled = false;
		this.parent.removeAttribute("data-disabled");
	}

	// update state
	updateState(data, newState) {
		this.setState(newState); // sets true/false, depending what state is
		if (this.type === "list") {
			this.item.checked = newState; // if checkbox, set is as checked/unchecked
		} else {
			switch (this.item.tagName) {
				case "INPUT":
					this.item.value = data.item.value; // setting same input value as the one that triggered this function
					break;
				case "SELECT":
					this.item.selectedIndex = data.item.selectedIndex; // if select, setting the same selected option, as the one that triggered func
					break;
				case "WDN-SELECT":
					this.item.setActiveOptionByValue(data.item.selected_option.value);
					this.value = data.value;
					break;
			}
		}
	}

	// activates/deactivates filters with the same id, based on passed state
	setFiltersActiveState(isActive) {
		var filters = this.getFiltersById(this.id); // gets all components with the same ID
		filters.forEach(function (filter) {
			// if filter is not the same one that triggered this function
			if (filter !== this) {
				// by passing "this", we can fill the input values based on "this" filter, that triggrered the function
				filter.updateState(this, isActive);
			}
		}, this);
	}

	deactivateSameFilters() {
		this.setFiltersActiveState(false); // passing state
	}

	activateSameFilters() {
		this.setFiltersActiveState(true); // passing state
	}

	getFiltersById(id) {
		return document.querySelectorAll("wdn-filter[data-id='" + id + "']");
	}

	listOnClick() {
		if (this.isActive) {
			this.setInactive(); // sets filter as inactive
		} else {
			this.setActive(); // sets filter as active
		}
	}

	rangeOnChange() {
		// if input is empty
		if (this.item.value === "") {
			this.setInactive(); // sets filter as inactive
		} else {
			this.setActive(); // sets filter as active
		}
		this.customEvent({ name: "filter:interacted", detail: this });
	}

	clearPaginationParam() {
		// outside function, shared between other classes (eg. filter-remove etc.)
		//WDN.Filters.clearPaginationParam();
		document.dispatchEvent(
			new CustomEvent("filters:clear:pagination", { detail: {} })
		);
	}

	appendAvailabilityParam() {
		var urlParams = new URLSearchParams(location.search);
		if (!urlParams.has("filter.v.availability")) {
			var availabilityFilter = WDN.Filters.getFilterById(
				"filter.v.availability1"
			);
			availabilityFilter ? availabilityFilter.setActive() : "";
		}
	}

	sortOnChange() {
		this.value = this.item.selected_option.value;
		this.setActive();
	}

	// callback for both change and click events
	onInteraction() {
		this.clearPaginationParam(); // clearing pagination param from URL
		//	this.appendAvailabilityParam(); /// showing only available products
		switch (this.type) {
			case "price_range":
				this.rangeOnChange();
				break;
			case "sort_by":
				this.sortOnChange();
				break;
			default:
				this.listOnClick();
		}
		this.customEvent({ name: "filter:interacted", detail: this });
		this.customEvent({ name: "filtergroup:update", detail: this.groupId });
	}

	// loops through array and innerHTMLs second param
	loopAndInsert(arr, content) {
		arr.forEach(function (item) {
			item.innerHTML = content;
		});
	}

	money(price) {
		return WDN.Money.Format(price);
	}

	// finds data-filter-price="min" containers and outputs min range price
	outputMinRangePrice() {
		var minContainers = document.querySelectorAll(
			"[" + this.config.price_range_attribute + '="min"]'
		);
		this.loopAndInsert(minContainers, this.money(this.item.min));
	}

	// finds data-filter-price="max" containers and outputs max range price
	outputMaxRangePrice() {
		var maxContainers = document.querySelectorAll(
			"[" + this.config.price_range_attribute + '="max"]'
		);
		this.loopAndInsert(maxContainers, this.money(this.item.max));
	}

	outputPrices() {
		if (this.type === "price_range") {
			this.outputMinRangePrice();
			this.outputMaxRangePrice();
		}
	}

	bind() {
		switch (this.type) {
			case "price_range":
				this.bindChange(); // binding change on select/input
				break;
			case "sort_by":
				this.item.onOptionSelect = this.onInteraction.bind(this);
				break;
			default:
				this.bindClick(); // binding click on checkbox
		}
	}

	bindClick() {
		this.item.addEventListener("click", this.onInteraction.bind(this));
	}

	bindChange() {
		this.item.addEventListener("change", this.onInteraction.bind(this));
	}

	onStartup() {
		if (this.type == "sort_by") {
			if (this.item.selected_option) {
				this.value = this.item.selected_option.value;
			} else {
				var selectedOption = this.item.querySelector("[data-selected]");
				if (!selectedOption) return;
				this.value = selectedOption.getAttribute("data-value");
			}
		}
	}

	start() {
		this.onStartup();
		this.outputPrices(); // outputs min and max range price to specific data- element
		this.customEvent({ name: "filtergroup:update", detail: this.groupId });
		this.bind(); // binds click/change depending on the filter type
	}
}

class WDNFilterRemove extends WDNElement {
	constructor() {
		super();
		this.config = {
			template: WDN.FilterConfig.template,
		};
		this.groupId = this.getAttribute("data-group");
		this.group = this.getGroupById(this.groupId);
		this.param = this.getAttribute("data-param"); // contains param name of active filter
		this.value = this.getAttribute("data-param-value"); // contains param value of active filter
		this.id = this.param + this.value;
		this.item = document.querySelector("wdn-filter[data-id='" + this.id + "']"); // contains filter item
		this.url_remove = this.clearTemplateFromURL(
			this.getAttribute("data-url-remove")
		); // contains url without "this" active filter

		this.start();
	}

	// since this component is being rendered inside dynamic template, it appends its template suffix to URL
	// liquid doesnt allow us to modify URL, we have to do it with JS
	clearTemplateFromURL(url) {
		var template = this.config.template;
		// replacing view URL param with empty value, depending on its position
		return url
			? url.replace("&view=" + template, "").replace("?view=" + template, "")
			: false;
	}

	clearPaginationParam() {
		//WDN.Filters.clearPaginationParam(); // shared function between classes
		document.dispatchEvent(
			new CustomEvent("filters:clear:pagination", { detail: {} })
		);
	}

	getGroupById = function (id) {
		return document.querySelector("wdn-filter-group[data-id='" + id + "']");
	};

	setGroupInactive() {
		if (this.group) {
			// ### Deactivate group items here
			this.group.clearSelections(); // clears all active items
		}
	}

	validateAvailability() {
		var urlParams = new URLSearchParams(location.search);
		var allParams = Array.from(urlParams);
		// if last remaining param
		if (allParams.length === 1) {
			document.dispatchEvent(
				new CustomEvent("filters:clear:availability", { detail: {} })
			);
		}
	}

	onClick() {
		this.clearPaginationParam(); // clears pagination param from URL
		if (this.item) {
			this.item.setInactive(); // Finding co-responding filter item and setting it inactive
		} else {
			this.setGroupInactive(); // if no specific item (eg. reset) was clicked
		}

		if (this.param === "filter.p.m.filter.tilbud") {
			var tilbudToggle = document.querySelector("tilbud-toggle");
			if (tilbudToggle) tilbudToggle.click();
		}

		this.validateAvailability();
		this.customEvent({ name: "filtergroup:update", detail: this.groupId });
	}

	bind() {
		this.addEventListener("click", this.onClick.bind(this));
	}

	start() {
		this.bind();
	}
}

class WDNFilterClear extends WDNElement {
	constructor() {
		super();
		this.searchParams = new URLSearchParams(location.search);
		this.exceptionList = []; // contains list of filter params that will be ignored on clear
		this.migrationList = [
			"q",
			"sort_by",
			"type",
			"options[prefix]",
			"options[unavailable_products",
		]; // list of params that will be migrated
		this.config = WDN.FilterConfig;
		this.url = this.config.current_url;
		this.template = this.config.template;
		this.queryParams = false;
		this.paramsToMigrate = {};
		this.bind();
	}

	updateListOfActiveFilters(id) {
		document.body.dispatchEvent(
			new CustomEvent("filtergroup:update", { detail: id })
		);
	}

	clearAllActiveFilters() {
		var filters = document.querySelectorAll(
			'wdn-filter[data-filter-active="true"]'
		);
		filters.forEach(function (filter) {
			if (this.exceptionList.indexOf(filter.id) < 0) {
				filter.setInactive();

				this.updateListOfActiveFilters(filter.groupId);
			}
		}, this);
		filters.length === 0
			? document.dispatchEvent(
				new CustomEvent("filters:loading:clear", { detail: {} })
			)
			: "";
	}

	onSuccess() {
		this.currentURL = location.pathname;
		this.migrateParams(); // appending earlier stored params back to url
		this.clearAllActiveFilters();
		history.pushState({}, "", this.currentURL);
	}

	migrateParams() {
		var prefix = "?";
		for (var key in this.paramsToMigrate) {
			if (this.paramsToMigrate.hasOwnProperty(key)) {
				this.currentURL =
					this.currentURL +
					prefix +
					encodeURI(key + "=" + this.paramsToMigrate[key]);
				prefix = "&";
			}
		}
	}

	storeParam(paramName) {
		if (this.searchParams.has(paramName)) {
			this.paramsToMigrate[paramName] = this.searchParams.get(paramName); // storing value on the object
			this.urlToFetch =
				this.urlToFetch +
				"&" +
				paramName +
				"=" +
				this.paramsToMigrate[paramName]; // appending it to url that will be fetched
		}
	}

	storeParams() {
		this.migrationList.forEach(function (paramName) {
			this.storeParam(paramName);
		}, this);
	}

	getUrlToFetch() {
		this.paramsToMigrate = {};
		this.urlToFetch = this.url + "?view=" + this.template;
		this.storeParams(); // loops through migration list and stores params

		var searchInCollection = document.querySelector("search-in-collection");
		if (searchInCollection) {
			if (searchInCollection.querySelector('input[name="q"]')) {
				var searchInCollectionQuery =
					searchInCollection.querySelector('input[name="q"]');
				var searchInCollectionID = searchInCollection.querySelector(
					'input[name="filter.p.m.product.collection_ids"]'
				);

				if (searchInCollectionQuery.value.length > 0) {
					this.urlToFetch =
						Shopify.routes.root +
						"search?q=" +
						searchInCollectionQuery.value +
						"&view=" +
						this.template +
						"&filter.p.m.product.collection_ids=" +
						searchInCollectionID.value;
				}
			}
		}

		return this.urlToFetch;
	}

	onClick() {
		document.dispatchEvent(
			new CustomEvent("filters:loading:set", { detail: {} })
		);
		var url = this.getUrlToFetch();
		WDN.Request.Get({
			url: url,
			onSuccess: this.onSuccess.bind(this),
			onError: this.onError.bind(this),
		});
	}

	onError() {
		document.dispatchEvent(
			new CustomEvent("filters:loading:clear", { detail: {} })
		);
	}

	bind() {
		this.addEventListener("click", this.onClick.bind(this));
	}
}

class WDNFilterPagination extends WDNElement {
	constructor() {
		super();
		this.config = {
			// targets data-filter-output="content" (grid), and uses insertAdjacentHTML instead of innerHTML
			attribute_value: "content",
			template: WDN.FilterConfig.template, // template suffix
		};
		this.current_page = parseInt(this.getAttribute("data-current")); // holds current pagination page
		this.type = this.getAttribute("data-type"); // "previous" or "next", if pagination is prev-next
		this.link = this.querySelector("a");
		this.src = this.link.getAttribute("href");
		this.start();
	}

	getNewPageOffset() {
		return this.type === "next" ? this.current_page + 1 : this.current_page - 1;
	}

	addParamToUrl() {
		this.urlParams = new URLSearchParams(location.search);
		var upcomingPage = this.getNewPageOffset();
		this.urlParams.set("page", upcomingPage);
		history.pushState({}, "", location.pathname + "?" + this.urlParams);
	}

	// since pagination content is appended to grid, we have to remove load more button after the content is inserted
	removeElement() {
		this.parentNode.parentNode.remove();
	}

	onFetch(res) {
		this.addParamToUrl(); // updates url and sets
		document.dispatchEvent(
			new CustomEvent("filters:fetch:success", {
				detail: { res: res, settings: this.config, pagination: true },
			})
		);
		this.removeElement();
		this.isFetching = false;
	}

	onFetchError() {
		this.isFetching = false;
	}

	onClick(e) {
		e ? e.preventDefault() : "";
		if (this.isFetching) return;
		this.isFetching = true;
		//WDN.Filters.setLoading();
		document.dispatchEvent(
			new CustomEvent("filters:loading:set", { detail: {} })
		);
		WDN.Request.Get({
			url: this.src,
			onSuccess: this.onFetch.bind(this),
			onError: this.onFetchError.bind(this),
		});
	}

	modifySrc() {
		if (this.src.indexOf("view=" + this.template) < 0) {
			this.src = this.src + "&view=" + this.config.template;
		}
	}

	bind() {
		if (this.link) {
			this.link.addEventListener("click", this.onClick.bind(this));
		}
	}

	start() {
		this.modifySrc();
		this.bind();
	}
}

if (typeof WDN.Filters === "undefined") {
	WDN.Filters = (function () {
		var config = {
			output_attribute: "data-filter-output",
			load_event: "filters:load", // module listens for this custom event
			autoInit: true, // defines custom elements on load
		};

		var Filters;

		Filters = function () {
			this.parser = new DOMParser(); // we will use this later to parse the response
			this.wasLoaded = false; // tells us whether the filters were loaded
			this.config = WDN.FilterConfig;
			this.controlsWrapper = document.querySelector(".filter-controls");
			this.searchResultWrapper = document.querySelector(
				"[data-results-wrappper]"
			);
			this.groups = document.querySelectorAll("wdn-filter-group");
			this.init();
		};

		Filters.prototype.parseResponse = function (res) {
			this.parsedResponse = this.parser.parseFromString(res, "text/html");
		};

		// since section API "ignores" layout none and wraps layout in <div>
		// querying script and getting the dump as JSON
		Filters.prototype.validateResponse = function () {
			var script = this.parsedResponse.querySelector("script");
			this.responseAsJSON = false;
			if (script) {
				this.responseAsJSON = JSON.parse(script.innerText);
			}
		};

		// getOutputsByValue("content") => query selects all [data-filter-output="content"]
		Filters.prototype.getOutputsByValue = function (value) {
			return document.querySelectorAll(
				"[" + config.output_attribute + "='" + value + "']"
			);
		};

		Filters.prototype.renderResponseItem = function (key, settings) {
			var isPagination = settings && settings.attribute_value === key;
			// targets  eg. [data-filter-output="controls"]
			var outputs = this.getOutputsByValue(key);
			// if fetch was made by pagination, on render, we insertAdjacentHTML
			outputs.forEach(function (output) {
				var responseItem = this.responseAsJSON[key].replaceAll(
					"backslash",
					String.fromCharCode(92)
				);
				if (isPagination) {
					const scrollY = window.scrollY;
					output.insertAdjacentHTML("beforeend", responseItem);
					window.scrollTo(0, scrollY);
				} else {
					output.innerHTML = responseItem;
				}
			}, this);
		};

		Filters.prototype.getFiltersById = function (id) {
			return document.querySelectorAll("wdn-filter[data-id='" + id + "']");
		};

		Filters.prototype.getFilterById = function (id) {
			return document.querySelector("wdn-filter[data-id='" + id + "']");
		};

		// gets Controls from API response, loops through them and validates custom HTML elements
		Filters.prototype.updateControls = function () {
			var controlsRes = this.responseAsJSON["controls"] || {};
			for (var key in controlsRes) {
				if (controlsRes.hasOwnProperty(key)) {
					var responseItem = controlsRes[key]; // contains filter info from API response
					// checking if response filter is disabled
					if (responseItem.isDisabled) {
						this.disableFilterList(key); // disabling filters
					} else {
						this.enableFilterList(key); // enabling filters
					}
				}
			}
		};

		Filters.prototype.activateFilterList = function (id) {
			var filter = this.getFilterById(id);
			filter ? filter.setActive() : "";
		};

		Filters.prototype.deactivateFilterList = function (id) {
			var filter = this.getFilterById(id);
			filter ? filter.setInactive() : "";
		};

		/**
		 *
		 * @param {string} id // pass the ID of the filter, and will enable all of them
		 * eg. enableFilterList("filter.v.availability1")
		 */

		Filters.prototype.enableFilterList = function (id) {
			var filters = this.getFiltersById(id); // gets all filter components with the same id
			filters.forEach(function (filter) {
				filter.enable();
			});
		};

		/**
		 *
		 * @param {string} id // pass the ID of the filter, and will disable all of them
		 * eg. disableFilterList("filter.v.availability1")
		 */
		Filters.prototype.disableFilterList = function (id) {
			var filters = this.getFiltersById(id); // gets all filter components with the same id
			filters.forEach(function (filter) {
				filter.disable();
			});
		};

		Filters.prototype.validateGroups = function () {
			this.groups.forEach(function (group) {
				group.validateFilters();
			});
		};

		// since this is shared function between classes, settings are passed only during pagination
		// then we know we need to append content instead innerHTML
		Filters.prototype.renderResponse = function (settings) {
			var response = this.responseAsJSON;
			if (response) {
				this.controlsWrapper.setAttribute(
					"data-has-active-filters",
					"" + response.active_filters !== ""
				);

				for (var key in response) {
					if (response.hasOwnProperty(key)) {
						this.renderResponseItem(key, settings);
						if (key === "controls") {
							this.updateControls();
							this.validateGroups();
						}
					}
				}
			}
		};

		// shared function between classes, removes page param from URL
		Filters.prototype.clearPaginationParam = function () {
			var urlParams = new URLSearchParams(location.search);
			if (urlParams.has("page")) {
				urlParams.delete("page");
				history.pushState({}, "", location.pathname + "?" + urlParams);
			}
		};

		Filters.prototype.setLoading = function () {
			document.body.setAttribute("data-loading", "");
		};

		Filters.prototype.clearLoading = function () {
			document.body.removeAttribute("data-loading");
		};

		Filters.prototype.getCountTranslation = function (count) {
			var count = parseInt(count);
			var translations = this.config.translations;
			var translation = "";
			switch (count) {
				case 0:
					translation = translations.zero;
					break;
				case 1:
					translation = translations.one;
					break;
				default:
					translation = translations.other;
					break;
			}
			return translation;
		};

		Filters.prototype.outputResultCount = function () {
			this.count_containers = document.querySelectorAll("[data-result-count]");
			this.count_containers.forEach(function (container) {
				container.innerHTML = this.responseAsJSON.result_count;
			}, this);
		};

		Filters.prototype.updateSearchHeader = function () {
			if (this.searchResultWrapper) {
				this.searchResultWrapper.innerHTML = this.getCountTranslation(
					this.responseAsJSON.result_count
				);
				this.outputResultCount();
			}
		};

		Filters.prototype.output_single_count = function () {
			for (var id in this.responseAsJSON.controls) {
				if (this.responseAsJSON.controls.hasOwnProperty(id)) {
					var filter_data = this.responseAsJSON.controls[id];
					var filter = this.getFilterById(id);
					if (filter) {
						filter.set_count(filter_data.values);
					}
				}
			}
		};

		Filters.prototype.updateGroups = function () {
			this.groups.forEach(function (group) {
				group.outputActiveFilters();
			});
		};

		Filters.prototype.onFetch = function (e) {
			this.parseResponse(e.detail.res); // parsing response as Node
			this.validateResponse(); // queryselecting and JSON parsing script's innertext
			this.renderResponse(e.detail.settings); // reads JSON dump and renders content to suitable containers
			this.updateSearchHeader();
			this.output_single_count();
			this.outputResultCount();
			this.updateGroups();
			this.clearLoading();
			document.body.dispatchEvent(
				new CustomEvent("filters:onfetch", { detail: e.detail })
			);
		};

		Filters.prototype.clearAvailabilityParam = function () {
			var availabilityFilter = this.getFilterById("filter.v.availability1");
			if (!availabilityFilter) return;
			availabilityFilter.setInactive();
		};

		Filters.prototype.defineCustomElements = function () {
			if (!this.wasLoaded) {
				if (!customElements.get("wdn-filter-group")) {
					customElements.define("wdn-filter-group", WDNFilterGroup);
				}

				if (!customElements.get("wdn-filter")) {
					customElements.define("wdn-filter", WDNFilter);
				}

				if (!customElements.get("wdn-filter-clear")) {
					customElements.define("wdn-filter-clear", WDNFilterClear);
				}
				if (!customElements.get("wdn-filter-remove")) {
					customElements.define("wdn-filter-remove", WDNFilterRemove);
				}
				if (!customElements.get("wdn-filter-pagination")) {
					customElements.define("wdn-filter-pagination", WDNFilterPagination);
				}

				this.wasLoaded = true;
				this.validateGroups(); // hides filter group if all items within group are disabled

				document.addEventListener(
					"filters:clear:pagination",
					this.clearPaginationParam.bind(this)
				);
				document.addEventListener(
					"filters:loading:set",
					this.setLoading.bind(this)
				);
				document.addEventListener(
					"filters:loading:clear",
					this.clearLoading.bind(this)
				);
				document.addEventListener(
					"filters:fetch:success",
					this.onFetch.bind(this)
				);
				document.addEventListener(
					"filters:clear:availability",
					this.clearAvailabilityParam.bind(this)
				);
			}
		};

		Filters.prototype.listenForInit = function () {
			document.addEventListener(
				config.load_event,
				this.defineCustomElements.bind(this)
			);
		};

		Filters.prototype.init = function () {
			if (config.autoInit) {
				this.defineCustomElements(); // defining custom elements
			}
			this.listenForInit(); // listening for custom event
		};

		return Filters;
	})();
}

class WDNFilterSelect extends WDNSelect {
	constructor() {
		super();
		this.closer = this.querySelector("[data-dropdown-close]");
		if (this.closer) {
			this.closer.addEventListener("click", this.shrinkContainer.bind(this));
		}

		this.onShrink = function () {
			document.body.classList.remove("filter--active");
		};

		this.onExpand = function () {
			document.body.classList.add("filter--active");
		};
	}

	triggerOnClick() {
		if (this.isActive) {
			this.shrinkContainer();
		} else {
			this.expandContainer();
		}
	}
}

class WDNSlide extends HTMLElement {
	constructor() {
		super();
		this.id = this.getAttribute("data-id");
		this.triggers = this.getTriggersById(this.id);
		this.closers = this.getClosersById(this.id);
		this.isVisible = this.getAttribute("data-visible") === "";
		this.scroll_container = this.querySelector("[data-scroll-container]");
		this.init();
	}

	setState(state) {
		this.isVisible = state;
		if (state) {
			this.setAttribute("data-visible", "");
		} else {
			this.removeAttribute("data-visible");
		}
	}

	adjustScrollContainer(state) {
		if (!this.scroll_container || !state) return;
		this.scroll_container.scroll(0, 0); // reset scroll position to top
	}

	toggle() {
		this.adjustScrollContainer(!this.isVisible);
		this.setState(!this.isVisible);
	}
	openOverlay(overlay_id) {
		document.body.dispatchEvent(
			new CustomEvent("overlay:open", {
				detail: {
					id: overlay_id,
				},
			})
		);
	}

	triggerOnClick(e) {
		var overlay_id = e.currentTarget.getAttribute("data-overlay-id");
		this.toggle();
		if (!overlay_id || overlay_id == "") return;
		// in order to hide transition between slides
		setTimeout(
			function () {
				this.openOverlay(overlay_id);
			}.bind(this),
			100
		);
	}

	getTriggersById(id) {
		return document.querySelectorAll("[data-slide-to='" + id + "']");
	}

	getClosersById(id) {
		return document.querySelectorAll("[data-slide-back='" + id + "']");
	}

	closerOnClick() {
		this.setState(false);
	}

	onDrawerClose(e) {
		this.isVisible ? this.setState(false) : "";
	}

	bindTriggers() {
		this.triggers.forEach(function (trigger) {
			trigger.addEventListener("click", this.triggerOnClick.bind(this));
		}, this);
	}

	bindClosers() {
		this.closers.forEach(function (closer) {
			closer.addEventListener("click", this.closerOnClick.bind(this));
		}, this);
	}

	listenForDrawerClose() {
		document.body.addEventListener(
			"filter_modal:close",
			this.onDrawerClose.bind(this)
		);
	}

	bind() {
		this.bindTriggers();
		this.bindClosers();
		this.listenForDrawerClose();
	}
	init() {
		this.bind();
	}
}

customElements.define("wdn-slide", WDNSlide);
customElements.define("wdn-filter-select", WDNFilterSelect);

if (typeof WDN.RangeSlides === "undefined") {
	WDN.RangeSlides = (function () {
		var init, bind, slideOnInput, updateSlideBackground, onPriceRangeInput;
		var updateInputValue;

		var nodes = {
			sliders: document.querySelectorAll("[data-range-slide]"),
			slider_min_price: document.querySelectorAll(
				"[data-range-slide='min_price']"
			),
			slider_max_price: document.querySelectorAll(
				"[data-range-slide='max_price']"
			),
			filter_min_price: document.querySelector(
				"[data-filter-range='min_price']"
			),
			filter_max_price: document.querySelector(
				"[data-filter-range='max_price']"
			),
			min_price: document.querySelectorAll(
				"input[data-filter-param='filter.v.price.gte']"
			),
			max_price: document.querySelectorAll(
				"input[data-filter-param='filter.v.price.lte']"
			),
		};

		updateSlideBackground = function (el) {
			el.style.background = `linear-gradient(to right, #001E3C 0%, #001E3C ${((el.value - el.min) / (el.max - el.min)) * 100
				}%, #F1F5FB ${((el.value - el.min) / (el.max - el.min)) * 100
				}%, #F1F5FB 100%)`;
		};

		updateInputValue = function (el) {
			var filterKey = el.getAttribute("data-range-slide");
			var inputs = nodes[filterKey];
			if (!inputs) return;
			inputs.forEach(function (input) {
				input.value = el.value;
			});
		};

		onPriceRangeInput = function (el) {
			var filterKey = el.getAttribute("data-range-slide");
			var nodeId = "filter_" + filterKey;
			if (nodes[nodeId]) {
				nodes[nodeId].rangeOnChange();
			}
		};
		var debouncedCallback = WDN.Debounce(onPriceRangeInput, 500);

		slideOnInput = function () {
			updateSlideBackground(this);
			if (this.getAttribute("data-range-slide") !== "") {
				updateInputValue(this);
				debouncedCallback(this);
			}
		};

		var onSliderSet = function (e) {
			var inputs = nodes["slider_" + e.detail.param];
			if (inputs) {
				inputs.forEach(function (input) {
					input.value = parseInt(e.detail.value);
					updateSlideBackground(input);
				});
			}
		};

		bind = function () {
			nodes.sliders.forEach(function (slide) {
				updateSlideBackground(slide);
				slide.addEventListener("input", slideOnInput);
			});

			document.body.addEventListener("range_slider:set", onSliderSet);
		};

		reInit = function () {
			nodes = {
				sliders: document.querySelectorAll("[data-range-slide]"),
				slider_min_price: document.querySelectorAll(
					"[data-range-slide='min_price']"
				),
				slider_max_price: document.querySelectorAll(
					"[data-range-slide='max_price']"
				),
				filter_min_price: document.querySelector(
					"[data-filter-range='min_price']"
				),
				filter_max_price: document.querySelector(
					"[data-filter-range='max_price']"
				),
				min_price: document.querySelectorAll(
					"input[data-filter-param='filter.v.price.gte']"
				),
				max_price: document.querySelectorAll(
					"input[data-filter-param='filter.v.price.lte']"
				),
			};
			init();
		};

		init = function () {
			bind();
			if (nodes.filter_min_price) {
				if (nodes.filter_min_price.updateRangeSliders) {
					nodes.filter_min_price.updateRangeSliders();
				}
			}

			if (nodes.filter_max_price) {
				if (nodes.filter_max_price.updateRangeSliders) {
					nodes.filter_max_price.updateRangeSliders();
				}
			}
		};

		init();

		return {
			reInit,
		};
	})();
}

if (typeof WDN.FilterModal === "undefined") {
	WDN.FilterModal = (function () {
		var init, setupCallback, modalOnClose;
		var nodes = {
			modal: document.querySelector("wdn-modal[data-id='collection_filters']"),
		};

		modalOnClose = function () {
			// delayed so the closing transition is not visible
			setTimeout(function () {
				document.body.dispatchEvent(
					new CustomEvent("filter_modal:close", { detail: {} })
				);
			}, 500);
		};

		setupCallback = function () {
			nodes.modal.onClose = modalOnClose;
		};

		init = function () {
			if (!nodes.modal) return;
			setupCallback();
		};

		init();

		return {};
	})();
}

if (typeof WDN.CollectionList === "undefined") {
	WDN.CollectionList = (function () {
		var init, bind;
		var display_results, hide_results;
		var heroButtonOnClick, onFilterUpdateEvent;

		var nodes = {
			hero_button: document.querySelector("[data-categories-show]"),
			cards_wrapper: document.querySelector("[data-colllection-results]"),
			top_categories_wrapper: document.querySelector("[data-top-wrapper]"),
		};

		display_results = function () {
			var outerList = document.querySelector(".hero--collection-list");

			if (outerList) {
				outerList.classList.remove("hero--collection-list");
			}

			nodes.cards_wrapper.classList.remove("hidden");
			nodes.top_categories_wrapper.classList.add("hidden");
		};
		hide_results = function () {
			nodes.cards_wrapper.classList.add("hidden");
			nodes.top_categories_wrapper.classList.remove("hidden");
		};

		onFilterUpdateEvent = function () {
			display_results();
		};

		heroButtonOnClick = function (e) {
			e ? e.preventDefault() : "";
			display_results();
		};

		bind = function () {
			nodes.hero_button.addEventListener("click", heroButtonOnClick);
			document.body.addEventListener("filter:interacted", onFilterUpdateEvent);
		};

		init = function () {
			if (!nodes.cards_wrapper) return;
			bind();
		};

		init();
	})();
}

var WDN = WDN || {};

if (typeof WDN.TopCategories === "undefined") {
	WDN.TopCategories = (function () {
		var init, bind, windowOnScroll;
		var storeContainers, storeCards;
		var applyEffect, clearEffect;

		var config = {
			header_height: parseInt(
				document.documentElement.style.getPropertyValue("--header-height")
			),
		};

		var nodes = {
			categories: document.querySelectorAll("[data-top-category]"),
			cards: document.querySelectorAll("[data-collection-card]"),
		};

		var containers = [];
		var cards = {};
		applyEffect = function (container) {
			if (container.isActive) return;
			if (cards.hasOwnProperty(container.collection_handle)) {
				cards[container.collection_handle].setAttribute(
					"data-category-preview",
					""
				);
				container.isActive = true;
			}
		};

		clearEffect = function (container) {
			if (!container.isActive) return;
			if (cards.hasOwnProperty(container.collection_handle)) {
				cards[container.collection_handle].removeAttribute(
					"data-category-preview"
				);
				container.isActive = false;
			}
		};

		windowOnScroll = function () {
			var scrollPosition = window.scrollY + config.header_height;

			containers.forEach(function (container) {
				if (
					scrollPosition >= container.el_top &&
					scrollPosition <= container.el_max_top
				) {
					applyEffect(container);
				} else {
					clearEffect(container);
				}
			});
		};

		storeContainers = function () {
			nodes.categories.forEach(function (category) {
				var el_rect = category.getBoundingClientRect();
				var el_top_pos = el_rect.top + window.pageYOffset;
				containers.push({
					el: category,
					collection_handle: category.getAttribute("data-top-category"),
					el_top: el_top_pos,
					el_max_top: el_top_pos + category.offsetHeight,
					isActive: false,
				});
			});
		};

		storeCards = function () {
			nodes.cards.forEach(function (card) {
				var collection_handle = card.getAttribute("data-collection-card");
				cards[collection_handle] = card;
			});
		};

		var onHeaderHeightUpdate = function () {
			config.header_height = parseInt(
				document.documentElement.style.getPropertyValue("--header-height")
			);
		};

		var windowOnResize = function () {
			storeContainers();
		};

		bind = function () {
			window.addEventListener("scroll", windowOnScroll);
			window.addEventListener("window:resize", windowOnResize);
			document.body.addEventListener(
				"header_height:updated",
				onHeaderHeightUpdate
			);
		};

		init = function () {
			if (nodes.categories.length == 0) return;
			storeContainers();
			storeCards();
			bind();
		};
		init();
		return {};
	})();
}

if (typeof WDN.CollectionHero === "undefined") {
	WDN.CollectionHero = (function () {
		var init, bind;
		var onSectionReach, onSectionLeave;

		var Header = WDN.Header;
		var nodes = {
			sticky_element: document.querySelector("[data-collection-sticky]"),
		};

		var data = {
			sticky_active: false,
		};

		var getHeaderHeight = function () {
			return parseInt(
				document.documentElement.style.getPropertyValue("--header-height")
			);
		};

		setSlidesPerView = function (slidesPerView) {
			nodes.wdn_swiper.Swiper.params.slidesPerView = slidesPerView;
		};

		onSectionReach = function () {
			data.sticky_active = true;
			document.body.classList.add("header--noshadow");
		};

		var getStickyHeaderHeightCalc = function () {
			return getHeaderHeight() + nodes.sticky_element.offsetHeight;
		};

		onSectionLeave = function () {
			data.sticky_active = false;
			document.body.classList.remove("header--noshadow");
		};

		var onHeightUpdate = function () {
			var static_header_height = getHeaderHeight();
			var sticky_header_height = getStickyHeaderHeightCalc();
			if (static_header_height == sticky_header_height) return;
			if (data.sticky_active) {
				Header.updateVariable(sticky_header_height);
			} else {
				Header.resetHeight();
			}
		};

		bind = function () {
			document.body.addEventListener("reached:collection_hero", onSectionReach);
			document.body.addEventListener("left:collection_hero", onSectionLeave);
		};

		init = function () {
			if (!nodes.sticky_element) return;
			bind();

			document.documentElement.style.setProperty(
				"--collection-hero-sticky-height",
				nodes.sticky_element.offsetHeight + "px"
			);
		};

		init();
		return {};
	})();
}

(function () {
	class StockToggle extends HTMLElement {
		constructor() {
			super();
		}

		onClick() {
			this.inStockCheckbox.listOnClick();
			this.updateState();
		}

		onCheckboxClick() {
			this.updateState();
		}

		updateState() {
			this.isActive =
				this.inStockCheckbox.getAttribute("data-filter-active") === "true";

			if (this.isActive) {
				this.setAttribute("data-checked", "");
				return;
			}
			this.removeAttribute("data-checked");
		}

		connectedCallback() {
			this.inStockCheckbox = document.querySelector(
				"wdn-filter[data-id='filter.v.availability1']"
			);
			this.updateState();
			this.addEventListener("click", this.onClick.bind(this));
			this.inStockCheckbox.addEventListener(
				"click",
				this.onCheckboxClick.bind(this)
			);
			document.addEventListener(
				"filters:fetch:success",
				this.updateState.bind(this)
			);
		}
	}

	customElements.define("stock-toggle", StockToggle);
})();

var CollectionFiltersRenderer = new WDN.SectionRenderer({
	selectors: {
		output: "[data-collection-filters-content]",
	},
	autoInit: true,
	useCurrentRoot: true,
	replaceOutput: true,
	stripWrapper: true,
	sections: ["async-collection-filters"],
	callback: function () {
		new WDN.Filters();
		WDN.RangeSlides.reInit();

		filterModalAsyncLoad();

		// Configure Sticky desktop controls
		if (WDN.DesktopStickyFilters) WDN.DesktopStickyFilters.init();

		// Configure Sticky filter button
		if (!WDN.MobileStickyFilter) return;
		WDN.MobileStickyFilter.init();
	},
});

/* Filter modal async */
var filterModalAsyncLoad = function () {
	var loadFilterOnClickSelectors = [
		"wdn-modal-open[data-id='collection_filters']",
		".js-filter-triggers-list",
		"[data-slide-to='sort_by']",
		"#CollectionProducts #collection_filters",
	];

	var handleClickOnFilterModalLoad = function () {
		/* prevent loading again, if was already loaded by other things... */
		var modalContent = document.querySelector("wdn-modal#collection_filters");
		if (modalContent.querySelector(".filters")) {
			return;
		}

		fetch(
			window.location.pathname +
			"?sections=async-filter-modal" +
			"&" +
			window.location.search.replace("?", "")
		)
			.then((res) => res.json())
			.then((resJSON) => {
				var domParser = new DOMParser();
				var resHTML = domParser.parseFromString(
					resJSON["async-filter-modal"],
					"text/html"
				);
				document.querySelector("[data-filter-modal-content]").innerHTML =
					resHTML.querySelector(".shopify-section").innerHTML;

				if (this.hasAttribute("data-slide-to")) {
					modalContent.open();
					var slideToElem = document.querySelector(
						'wdn-filter-group[data-group-param="sort_by"]'
					);
					slideToElem.click();
				}

				WDN.RangeSlides.reInit();
				document.body.dispatchEvent(
					new CustomEvent("collection:mobile:filters:loaded")
				);
			})
			.catch((err) => console.warn(err));
	};

	loadFilterOnClickSelectors.forEach((selector) => {
		if (document.querySelector(selector)) {
			document
				.querySelector(selector)
				.addEventListener("click", handleClickOnFilterModalLoad);
		}
	});
};

/* Sticky support async */
(function () {
	if (window.innerWidth < 1900) return;
	new WDN.SectionRenderer({
		selectors: {
			output: "[data-collection-support-content]",
		},
		sections: ["async-collection-support"],
		useCurrentRoot: true,
		stripWrapper: true,
		triggers: [window],
		events: ["load"],
	});
})();

/* Mobile - Sticky filters button - functionality */
if (typeof WDN.MobileStickyFilter === "undefined") {
	WDN.MobileStickyFilter = (function () {
		var init;

		init = function () {
			var stickyButton = document.querySelector("[data-sticky-filters]");
			var filterTrigger = document.querySelector(
				"wdn-modal-open[data-id='collection_filters']"
			);

			if (!stickyButton || !filterTrigger) return;

			stickyButton.addEventListener("click", function () {
				filterTrigger.click();
			});
		};

		return {
			init,
		};
	})();
}

/* Desktop - Sticky filters */
if (typeof WDN.DesktopStickyFilters === "undefined") {
	WDN.DesktopStickyFilters = (function () {
		var init, assignNodes, assignBackgroundHeight;

		// Event handlers
		var handleWindowScroll, handleFiltersRefresh;

		var nodes = {};

		assignNodes = function () {
			nodes = {
				stickyCollectionOverview: document.querySelector(
					"[data-collection-sticky]"
				),
				filtersWrapper: document.querySelector(".filters-wrapper"),
				filtersBackground: document.querySelector(".filters-bg"),
				filtersControls: document.querySelector(".filter-controls"),
			};
		};

		assignBackgroundHeight = function () {
			var backgroundRect = nodes.filtersBackground.getBoundingClientRect();
			nodes.filtersWrapper.style.setProperty(
				"--controls-height",
				backgroundRect.height + "px"
			);
		};

		handleFiltersRefresh = function (e) {
			assignBackgroundHeight();

			var controlsTopPos =
				window.scrollY + nodes.filtersWrapper.getBoundingClientRect().top;

			// if pagination made refresh - do not scroll to filters
			if (e.detail && e.detail.pagination) return;

			// If sticky element not fixed - do not smooth scroll when filters are updated
			if (!nodes.filtersWrapper.classList.contains("filters--fixed")) return;

			// scroll to filters
			scroll({ top: controlsTopPos, behavior: "smooth" });
		};

		handleWindowScroll = function () {
			var wrapperTopPosition = nodes.filtersWrapper.getBoundingClientRect().top;
			var topWrapperNode = document.querySelector("[data-top-wrapper]");
			var isOnOverviewPage =
				nodes.stickyCollectionOverview &&
				!topWrapperNode.classList.contains("hidden");
			var stickyThreshold = -280; // Will stick filter when this amount & less is scrolled past filter wrapper

			// Handle overview page
			if (isOnOverviewPage) {
				if (wrapperTopPosition <= stickyThreshold) {
					nodes.filtersWrapper.classList.add(
						"filters--fixed",
						"filters--fixed-overview"
					);
				} else {
					nodes.filtersWrapper.classList.remove(
						"filters--fixed",
						"filters--fixed-overview"
					);
				}
				return;
			}

			// Handle general collection page
			if (wrapperTopPosition <= stickyThreshold) {
				nodes.filtersWrapper.classList.add("filters--fixed");
			} else {
				nodes.filtersWrapper.classList.remove("filters--fixed");
				// Remove overview class in case when switching from overview to normal collection page
				nodes.filtersWrapper.classList.remove("filters--fixed-overview");
			}
		};

		init = function () {
			assignNodes();
			// If filters not found - do not init
			if (!nodes.filtersWrapper) return;

			assignBackgroundHeight();

			// Listeners
			var handleWindowScrollDebounced = WDN.Debounce(handleWindowScroll, 35);
			window.addEventListener("scroll", handleWindowScrollDebounced);
			window.addEventListener("window:resize", assignBackgroundHeight);

			document.body.addEventListener("filters:onfetch", handleFiltersRefresh);
		};

		return {
			init,
		};
	})();
}

class filterTriggerOnSite extends HTMLElement {
	constructor() {
		super();

		this.filtersIsLoaded = false;
		this.filterType = this.getAttribute("name");
	}

	onClick() {
		var filterDrawer = document.querySelector("wdn-modal#collection_filters");

		filterDrawer.open();

		if (this.filtersIsLoaded) {
			var slideToOpen = filterDrawer.querySelector(
				'wdn-filter-group[data-group-param="' + this.filterType + '"]'
			);

			if (slideToOpen) {
				slideToOpen.querySelector("[data-slide-to]").click();
			}
		} else {
			document.body.addEventListener("collection:mobile:filters:loaded", () => {
				var slideToOpen = filterDrawer.querySelector(
					'wdn-filter-group[data-group-param="' + this.filterType + '"]'
				);

				if (slideToOpen) {
					slideToOpen.querySelector("[data-slide-to]").click();
				}
			});
		}
	}

	connectedCallback() {
		document.body.addEventListener("collection:mobile:filters:loaded", () => {
			this.filtersIsLoaded = true;
		});

		this.addEventListener("click", this.onClick.bind(this));
	}
}

customElements.define("filter-onsite-trigger", filterTriggerOnSite);

class searchInCollection extends HTMLElement {
	constructor() {
		super();
		this.collectionSectionId = this.getAttribute("data-section-id");
	}

	cacheElements() {
		this.form = this.querySelector("form");
		this.formQueryField = this.form.querySelector('input[name="q"]');
	}

	removeCollectionSpecificThings() {
		var listOfItemSelectors = [
			"collection-stock-overview",
			".filter-triggers-onsite",
		];

		listOfItemSelectors.forEach((selector) => {
			if (document.querySelector(selector)) {
				document.querySelector(selector).remove();
			}
		});
	}

	cacheFormData() {
		this.serializedForm = new FormData(this.form);
	}

	setSearchBaseURL() {
		this.searchURL = new URL(this.form.action);
		this.searchURL.searchParams.set(
			"filter.p.m.product.collection_ids",
			this.serializedForm.get("filter.p.m.product.collection_ids")
		);
		this.searchURL.searchParams.set(
			"sections",
			this.serializedForm.get("sections_to_load")
		);

		if (this.serializedForm.has("q")) {
			if (this.serializedForm.get("q").length > 0) {
				this.searchURL.searchParams.set("q", this.serializedForm.get("q"));
			}
		}
	}

	clearSearch() {
		this.collectionUrl = new URL(window.location.href);
		this.collectionUrl.searchParams.delete("page");
		this.collectionUrl.searchParams.delete("sections");
		this.collectionUrl.searchParams.delete("q");

		history.replaceState({}, "", this.collectionUrl.toString());

		this.collectionUrl.searchParams.set(
			"sections",
			this.collectionSectionId + ",async-filter-modal"
		);

		fetch(this.collectionUrl.toString())
			.then((res) => res.json())
			.then((resJSON) => {
				var domParser = new DOMParser();

				var rawRes = domParser.parseFromString(
					resJSON[this.collectionSectionId],
					"text/html"
				);
				var rawResFilter = domParser.parseFromString(
					resJSON["async-filter-modal"],
					"text/html"
				);

				var collectionPageRes = rawRes.querySelector(
					"#shopify-section-" + this.collectionSectionId
				);
				var outputContainer = document.querySelector(
					"#shopify-section-" + this.collectionSectionId
				);

				outputContainer.querySelector(".collectionPageMainProducts").innerHTML =
					collectionPageRes.querySelector(
						".collectionPageMainProducts"
					).innerHTML;
				outputContainer.querySelector(
					"[data-collection-filters-content]"
				).innerHTML = collectionPageRes.querySelector(
					"[data-collection-filters-content]"
				).innerHTML;
				outputContainer.querySelector(
					"[data-collection-filter-triggers-on-site]"
				).innerHTML = collectionPageRes.querySelector(
					"[data-collection-filter-triggers-on-site]"
				).innerHTML;

				document.querySelector("[data-filter-modal-content]").innerHTML =
					rawResFilter.querySelector(
						"#shopify-section-async-filter-modal"
					).innerHTML;
				document
					.querySelector(".collectionPageMainProducts")
					.classList.remove("search--is-loading");
			})
			.catch((err) => console.warn("err", err));
	}

	handleSubmit() {
		this.cacheFormData();
		this.search();
	}

	handleQueryChange() {
		document
			.querySelector(".collectionPageMainProducts")
			.classList.add("search--is-loading");

		this.cacheFormData();

		if (this.serializedForm.get("q").length > 0) {
			this.searchURL.searchParams.set("q", this.serializedForm.get("q"));
			this.search();

			return;
		}

		this.clearSearch();
	}

	onDesktopFiltersReload() {
		if (WDN.DesktopStickyFilters) WDN.DesktopStickyFilters.init();

		if (!WDN.MobileStickyFilter) return;
		WDN.MobileStickyFilter.init();
	}

	onSearchDone() {
		/* remove non-relevant things, when in search mode */
		this.removeCollectionSpecificThings();
		var domParser = new DOMParser();

		/* desktop filter */
		var sectionTemplateFilterHTML = domParser.parseFromString(
			this.searchResultsJSON["async-search-filters"],
			"text/html"
		);
		var filterOutputTarget = document.querySelector(
			"[data-collection-filters-content]"
		);

		if (sectionTemplateFilterHTML.querySelector(".filters-wrapper")) {
			filterOutputTarget.querySelector(".filters-wrapper").innerHTML =
				sectionTemplateFilterHTML.querySelector(".filters-wrapper").innerHTML;
		}

		this.onDesktopFiltersReload();

		/* mobile filter */
		var sectionTemplateMobileFilterHTML = domParser.parseFromString(
			this.searchResultsJSON["async-filter-modal"],
			"text/html"
		);
		var filterMobileOutputTarget = document.querySelector(
			"wdn-modal#collection_filters"
		);
		filterMobileOutputTarget.querySelector(
			"[data-filter-modal-content]"
		).innerHTML = sectionTemplateMobileFilterHTML.querySelector(
			"#shopify-section-async-filter-modal"
		).innerHTML;
		WDN.RangeSlides.reInit();

		/* products */
		var sectionTemplateSearchHTML = domParser.parseFromString(
			this.searchResultsJSON["template-search"],
			"text/html"
		);
		var searchResult = sectionTemplateSearchHTML.querySelector(
			'[data-filter-output="content"]'
		);
		var outputContainer = document.querySelector("#CollectionProducts");

		WDN.RangeSlides.reInit();

		if (searchResult) {
			searchResult = searchResult.innerHTML;
		} else {
			outputContainer.innerHTML = "";
			var noResultsText = sectionTemplateSearchHTML.querySelector(
				".search-template--blank .collection__search__results--blank"
			).innerHTML;
			var noResultsElement = document.createElement("p");

			noResultsElement.innerHTML = noResultsText;
			noResultsElement.classList.add(
				"collection__search-title--no-results",
				"tx:center"
			);
			searchResult = noResultsElement;
			outputContainer.appendChild(noResultsElement);
			return;
		}

		outputContainer.innerHTML = searchResult;
		document
			.querySelector(".collectionPageMainProducts")
			.classList.remove("search--is-loading");
	}

	search() {
		this.navigatorURL = new URL(window.location.href);
		console.warn(window.location.href);
		this.navigatorURL.searchParams.delete("page");
		this.navigatorURL.searchParams.set(
			"q",
			this.searchURL.searchParams.get("q")
		);

		/* we're removing page param here, lets also push this to the actual state of the page */
		history.replaceState({}, "", this.navigatorURL.toString());

		this.setSearchBaseURL();

		/* merge current params */
		this.navigatorURL.searchParams.forEach((value, key) => {
			if (key == "q") {
				this.searchURL.searchParams.delete("q");
				this.searchURL.searchParams.set(key, value);
			} else {
				this.searchURL.searchParams.append(key, value);
			}
		});

		fetch(this.searchURL.toString())
			.then((res) => res.json())
			.then((resJSON) => {
				this.searchResultsJSON = resJSON;
				this.onSearchDone();
			})
			.catch((err) => console.warn("error", err));
	}

	readInitialQueryFromLandingURL() {
		this.collectionURL = new URL(window.location.href);

		if (this.collectionURL.searchParams.has("q")) {
			if (this.collectionURL.searchParams.get("q").length > 0) {
				this.formQueryField.value = this.collectionURL.searchParams.get("q");
				console.warn("read initial", this.formQueryField.value);
			}
		}
	}

	connectedCallback() {
		this.cacheElements();
		this.readInitialQueryFromLandingURL();
		this.cacheFormData();
		this.setSearchBaseURL();

		this.formQueryField.addEventListener(
			"keyup",
			WDN.Debounce(this.handleQueryChange.bind(this), 225)
		);

		this.form.addEventListener("reset", this.clearSearch);
		this.formQueryField.addEventListener("reset", this.clearSearch);

		if (this.formQueryField.value.length > 0) {
			console.warn(this.formQueryField.value);
			this.handleSubmit();
		}

		this.form.addEventListener("submit", (e) => {
			e.preventDefault();
			this.handleSubmit();
		});
	}
}

customElements.define("search-in-collection", searchInCollection);

class ScrollToCollectionSearch extends HTMLElement {
	constructor() {
		super();
	}

	connectedCallback() {
		this.customCardsInCollection = document.querySelectorAll(
			'.collection-grid .grid__item--collection_sold-out[data-has-active-filters="false"][data-page="1"]'
		);

		if (this.customCardsInCollection.length > 0) {
			this.customCardsInCollection = Array.from(
				this.customCardsInCollection
			).filter((elem) => {
				if (elem.style.order) {
					if (parseInt(elem.style.order) <= 24) {
						return true;
					}
				}
			});
		}

		this.shortcutToSearch = this.closest(".collection-list-search-divider");


		if (this.customCardsInCollection.length > 0 && this.shortcutToSearch) {
			this.shortcutToSearch.style.order =
				parseInt(this.shortcutToSearch.style.order) +
				this.customCardsInCollection.length;
		}

		this.addEventListener("click", (e) => {
			e.preventDefault();

			this.target = document.querySelector("search-in-collection");
			if (!this.target) {
				return;
			}

			this.targetRect = this.target.getBoundingClientRect();
			this.correctPosBy = 200; /* px */

			this.scrollToY = this.targetRect.top + window.scrollY - this.correctPosBy;

			window.scrollTo({
				top: this.scrollToY,
				behavior: "smooth",
			});
		});
	}
}

customElements.define("scrollto-collectionsearch", ScrollToCollectionSearch);
